export default __webpack_public_path__ + "static/media/gallery_21.88267e02.jpg";